let banklist = ["Boubyan", "KFH", "NBK", "NBK Credit", "Cash"];
export default banklist;
